import axiosConfig from '../modules/axiosConfig'
import utils from '../modules/utils'
const HTTP = axiosConfig.HTTP

// state
const state = {
  loadingDropMenu: false,
  appProgram: '',
  loadingProgram: false,
  programData: {},
  lang: 'ES',
  loadingCommerce: false,
  loadingCanales: false,
  loadingTemplates: false,
  loadingAllAcounts: false,
  countsData: {},
  loadingCountsData: true,
  accountType: 'T'
}

// getters
const getters = {
  getDataProgram () {
    return state.programData
  },
  getcountsData () {
    return state.countsData
  },
  getDropMenuState () {
    return state.loadingDropMenu
  },
  getSelectedProgram () {
    return state.appProgram
  },
  getProgramState () {
    return state.loadingProgram
  },
  getLang () {
    return state.lang
  },
  getLoadingCommerce () {
    return state.loadingCommerce
  },
  getLoadingTemplates () {
    return state.loadingTemplates
  },
  getLoadingCanales () {
    return state.loadingCanales
  },
  getLoadingAllAccounts () {
    return state.loadingAllAcounts
  },
  getLoadingCounts () {
    return state.loadingCountsData
  },
  getTypeAccount () {
    return state.accountType
  }
}

// actions
const actions = {
  async getListPrograms ({ commit, rootState }, data) {
    commit('LOADING_DROP_MENU_FINISHED', false)
    const config = rootState.appConfig.configFile
    const appParams = JSON.parse(sessionStorage.getItem('appParams'))
    const storageAppToken = sessionStorage.getItem('token')
    const hashToken = utils.SHA256(appParams.entidad + storageAppToken + appParams.canal)
    let body = {}
    body = Object.assign({}, {
      runService: {
        opData: {
          avanzar: false,
          businesstimeout: '',
          canal: config.canal,
          claveFin: '',
          claveInicio: '',
          entidad: config.entidad,
          idioma: state.lang.toUpperCase(),
          indMasDatos: '',
          oficina: '',
          pantPagina: '',
          retroceder: false,
          mainUser: appParams.mainUser,
          securityToken: hashToken
        },
        eEntrada: {
          codcadena: data.codcadena,
          codcom: data.codcom,
          codentid: config.entidad,
          codholding: data.holding,
          codprogr: '',
          desccpro: ''
        }
      }
    })
    try {
      const response = await HTTP.post(config.endpoints.listPrograms, body)
      sessionStorage.setItem('token', response.data.runServiceResponse.return.securityToken)
      commit('LOADING_DROP_MENU_FINISHED', true)
      if (response.data.runServiceResponse.return.retorno === '039') {
        commit('SET_ERROR', {
          isError: true,
          isFatal: true,
          msg: 'La sesión ha expirado. Reinicie el registro.'
        })
      }
      if (response.data.runServiceResponse.return.retorno === '021') {
        commit('SET_ERROR', {
          isError: true,
          isFatal: true,
          msg: 'Token de seguridad incorrecto.'
        })
      }
      return response.data.runServiceResponse.return
    } catch (error) {
      commit('SET_ERROR', {
        isError: true,
        isFatal: false,
        msg: error
      }, { root: true })
    }
  },
  async getProgram ({ commit, rootState }) {
    commit('LOADING_PROGRAM_FINISHED', false)
    const config = rootState.appConfig.configFile
    const appParams = JSON.parse(sessionStorage.getItem('appParams'))
    const appProgram = sessionStorage.getItem('appProgram')
    const storageAppToken = sessionStorage.getItem('token')
    const hashToken = utils.SHA256(appParams.entidad + storageAppToken + appParams.canal)
    let body = {}
    body = Object.assign({}, {
      runService: {
        opData: {
          avanzar: false,
          businesstimeout: '',
          canal: config.canal,
          claveFin: '',
          claveInicio: '',
          entidad: config.entidad,
          idioma: state.lang.toUpperCase(),
          indMasDatos: '',
          oficina: '',
          pantPagina: '',
          retroceder: false,
          mainUser: appParams.mainUser,
          securityToken: hashToken
        },
        eEntrada: {
          codcatal: '',
          codentid: appParams.entidad,
          codprogr: appProgram,
          codtipcu: '',
          desccata: '',
          desccpro: '',
          fechpcan: {
            anno: '',
            dia: '',
            format: '',
            mes: '',
            nombreDia: '',
            nombreMes: '',
            valueDate: ''
          },
          fechpenv: {
            anno: '',
            dia: '',
            format: '',
            mes: '',
            nombreDia: '',
            nombreMes: '',
            valueDate: ''
          },
          fechucan: {
            anno: '',
            dia: '',
            format: '',
            mes: '',
            nombreDia: '',
            nombreMes: '',
            valueDate: ''
          },
          fechvigd: {
            anno: '',
            dia: '',
            format: '',
            mes: '',
            nombreDia: '',
            nombreMes: '',
            valueDate: ''
          },
          fechvigh: {
            anno: '',
            dia: '',
            format: '',
            mes: '',
            nombreDia: '',
            nombreMes: '',
            valueDate: ''
          },
          indanpto: '',
          indenvex: '',
          indptotr: '',
          inprinme: '',
          numtopto: '0',
          percanje: '',
          perinfor: '',
          pervigen: '',
          ratequiv: '0',
          xcritcad: '',
          xtranptn: ''
        }
      }
    })
    try {
      const response = await HTTP.post(config.endpoints.getProgram, body)
      sessionStorage.setItem('token', response.data.runServiceResponse.return.securityToken)
      commit('LOADING_PROGRAM_FINISHED', true)
      commit('SET_DATA_PROGRAM', response.data.runServiceResponse.return.registros)
      if (response.data.runServiceResponse.return.retorno === '039') {
        commit('SET_ERROR', {
          isError: true,
          isFatal: true,
          msg: 'La sesión ha expirado. Reinicie el registro.'
        })
      }
      if (response.data.runServiceResponse.return.retorno === '021') {
        commit('SET_ERROR', {
          isError: true,
          isFatal: true,
          msg: 'Token de seguridad incorrecto.'
        })
      }
      return response.data.runServiceResponse.return.registros
    } catch (error) {
      commit('SET_ERROR', {
        isError: true,
        isFatal: false,
        msg: error
      }, { root: true })
    }
  },
  async getCounts ({ commit, rootState }) {
    commit('LOADING_COUNTSDATA_FINISHED', false)
    const config = rootState.appConfig.configFile
    const appParams = JSON.parse(sessionStorage.getItem('appParams'))
    const appProgram = sessionStorage.getItem('appProgram')
    const storageAppToken = sessionStorage.getItem('token')
    const hashToken = utils.SHA256(appParams.entidad + storageAppToken + appParams.canal)
    let body = {}
    body = Object.assign({}, {
      runService: {
        opData: {
          avanzar: false,
          businesstimeout: '',
          canal: config.canal,
          claveFin: '',
          claveInicio: '',
          entidad: config.entidad,
          idioma: state.lang.toUpperCase(),
          indMasDatos: 'N',
          oficina: '',
          pantPagina: '',
          retroceder: false,
          mainUser: appParams.mainUser,
          securityToken: hashToken
        },
        eEntrada: {
          codentid: config.entidad,
          codprogr: appProgram
        }
      }
    })
    try {
      const response = await HTTP.post(config.endpoints.getCounts, body)
      sessionStorage.setItem('token', response.data.runServiceResponse.return.securityToken)
      commit('LOADING_COUNTSDATA_FINISHED', true)
      commit('SET_DATA_COUNTS', response.data.runServiceResponse.return.registros)
      if (response.data.runServiceResponse.return.retorno === '039') {
        commit('SET_ERROR', {
          isError: true,
          isFatal: true,
          msg: 'La sesión ha expirado. Reinicie el registro.'
        })
      }
      if (response.data.runServiceResponse.return.retorno === '021') {
        commit('SET_ERROR', {
          isError: true,
          isFatal: true,
          msg: 'Token de seguridad incorrecto.'
        })
      }
      return response.data.runServiceResponse.return.registros
    } catch (error) {
      commit('SET_ERROR', {
        isError: true,
        isFatal: false,
        msg: error
      }, { root: true })
    }
  },
  async getCommerce ({ commit, rootState }, data) {
    commit('LOADING_COMMERCE_FINISHED', false)
    const config = rootState.appConfig.configFile
    const appParams = JSON.parse(sessionStorage.getItem('appParams'))
    const appProgram = sessionStorage.getItem('appProgram')
    const storageAppToken = sessionStorage.getItem('token')
    const hashToken = utils.SHA256(appParams.entidad + storageAppToken + appParams.canal)
    let body = {}
    if (typeof data !== 'undefined') {
      body = Object.assign({}, {
        runService: {
          opData: {
            avanzar: data.avanzar ? data.avanzar : false,
            businesstimeout: '',
            canal: config.canal,
            claveFin: data.claveFin ? data.claveFin : '',
            claveInicio: data.claveInicio ? data.claveInicio : '',
            entidad: config.entidad,
            idioma: state.lang.toUpperCase(),
            indMasDatos: '',
            oficina: '',
            pantPagina: '',
            retroceder: data.retroceder ? data.retroceder : false,
            mainUser: appParams.mainUser,
            securityToken: hashToken
          },
          eEntrada: {
            codentid: config.entidad,
            codprogr: appProgram,
            codcanal: '',
            descanal: '',
            porbanco: 0,
            porcanal: 0
          }
        }
      })
    } else {
      body = Object.assign({}, {
        runService: {
          opData: {
            avanzar: false,
            businesstimeout: '',
            canal: config.canal,
            claveFin: '',
            claveInicio: '',
            entidad: config.entidad,
            idioma: state.lang.toUpperCase(),
            indMasDatos: '',
            oficina: '',
            pantPagina: '',
            retroceder: false,
            mainUser: appParams.mainUser,
            securityToken: hashToken
          },
          eEntrada: {
            codentid: config.entidad,
            codprogr: appProgram,
            codcanal: '',
            descanal: '',
            porbanco: 0,
            porcanal: 0
          }
        }
      })
    }
    try {
      const response = await HTTP.post(config.endpoints.getCommerce, body)
      sessionStorage.setItem('token', response.data.runServiceResponse.return.securityToken)
      commit('LOADING_COMMERCE_FINISHED', true)
      if (response.data.runServiceResponse.return.retorno === '039') {
        commit('SET_ERROR', {
          isError: true,
          isFatal: true,
          msg: 'La sesión ha expirado. Reinicie el registro.'
        })
      }
      if (response.data.runServiceResponse.return.retorno === '021') {
        commit('SET_ERROR', {
          isError: true,
          isFatal: true,
          msg: 'Token de seguridad incorrecto.'
        })
      }
      return response.data.runServiceResponse.return
    } catch (error) {
      commit('SET_ERROR', {
        isError: true,
        isFatal: false,
        msg: error
      }, { root: true })
    }
  },
  async getTemplates ({ commit, rootState }, data) {
    commit('LOADING_TEMPLATES_FINISHED', false)
    const config = await rootState.appConfig.configFile
    const appParams = JSON.parse(sessionStorage.getItem('appParams'))
    const appProgram = sessionStorage.getItem('appProgram')
    const storageAppToken = sessionStorage.getItem('token')
    const hashToken = utils.SHA256(appParams.entidad + storageAppToken + appParams.canal)
    let body = {}
    // console.log('data')
    // console.log(typeof data)
    // console.log(data)
    // console.log('config')
    // console.log(config)
    body = Object.assign({}, {
      runService: {
        opData: {
          avanzar: data.avanzar ? data.avanzar : false,
          businesstimeout: '',
          canal: config && config.canal ? config.canal : '',
          claveFin: data.claveFin ? data.claveFin : '',
          claveInicio: data.claveInicio ? data.claveInicio : '',
          entidad: config && config.entidad ? config.entidad : '',
          idioma: state.lang.toUpperCase(),
          indMasDatos: '',
          oficina: '',
          pantPagina: '',
          retroceder: data.retroceder ? data.retroceder : false,
          mainUser: appParams.mainUser,
          securityToken: hashToken
        },
        eEntrada: {
          cod_plantilla: '',
          codentid: config && config.entidad ? config.entidad : '',
          codprogr: appProgram,
          descripcion: '',
          fechafin: {
            anno: '',
            dia: '',
            format: '',
            mes: '',
            nombreDia: '',
            nombreMes: '',
            valueDate: ''
          },
          fechaici: {
            anno: '',
            dia: '',
            format: '',
            mes: '',
            nombreDia: '',
            nombreMes: '',
            valueDate: ''
          },
          imp_minimo: 0,
          num_cup_act: 0,
          num_max_cup: 0
        }
      }
    })
    try {
      // console.log(config.endpoints.getTemplates, body)
      const response = await HTTP.post(config.endpoints.getTemplates, body)
      // console.log(response)
      sessionStorage.setItem('token', response.data.runServiceResponse.return.securityToken)
      commit('LOADING_TEMPLATES_FINISHED', true)
      if (response.data.runServiceResponse.return.retorno === '039') {
        commit('SET_ERROR', {
          isError: true,
          isFatal: true,
          msg: 'La sesión ha expirado. Reinicie el registro.'
        })
      }
      if (response.data.runServiceResponse.return.retorno === '021') {
        commit('SET_ERROR', {
          isError: true,
          isFatal: true,
          msg: 'Token de seguridad incorrecto.'
        })
      }
      return response.data.runServiceResponse.return
    } catch (error) {
      commit('SET_ERROR', {
        isError: true,
        isFatal: false,
        msg: error
      }, { root: true })
    }
  },
  async getCanales ({ commit, rootState }, data) {
    commit('LOADING_CANALES_FINISHED', false)
    const config = rootState.appConfig.configFile
    const appParams = JSON.parse(sessionStorage.getItem('appParams'))
    const storageAppToken = sessionStorage.getItem('token')
    const hashToken = utils.SHA256(appParams.entidad + storageAppToken + appParams.canal)
    // const appProgram = sessionStorage.getItem('appProgram')
    let body = {}
    if (typeof data !== 'undefined') {
      // console.log('getCanales U9CLCAN', data)
      body = Object.assign({}, {
        runService: {
          opData: {
            avanzar: data.avanzar ? data.avanzar : false,
            businesstimeout: '',
            canal: config.canal,
            claveFin: data.claveFin ? data.claveFin : '',
            claveInicio: data.claveInicio ? data.claveInicio : '',
            entidad: config.entidad,
            idioma: state.lang.toUpperCase(),
            indMasDatos: data.indMasDatos ? data.indMasDatos : 'N',
            pantPagina: '',
            retroceder: data.retroceder ? data.retroceder : false,
            mainUser: appParams.mainUser,
            securityToken: hashToken
          },
          eEntrada: {
            codentid: config.entidad
          }
        }
      })
    } else {
      console.log('getCanales typeof data undefined')
    }
    try {
      // console.log(config.endpoints.getCanales, body)
      const response = await HTTP.post(config.endpoints.getCanales, body)
      sessionStorage.setItem('token', response.data.runServiceResponse.return.securityToken)
      commit('LOADING_CANALES_FINISHED', true)
      if (response.data.runServiceResponse.return.retorno === '039') {
        commit('SET_ERROR', {
          isError: true,
          isFatal: true,
          msg: 'La sesión ha expirado. Reinicie el registro.'
        })
      }
      if (response.data.runServiceResponse.return.retorno === '021') {
        commit('SET_ERROR', {
          isError: true,
          isFatal: true,
          msg: 'Token de seguridad incorrecto.'
        })
      }
      return response.data.runServiceResponse.return
    } catch (error) {
      commit('SET_ERROR', {
        isError: true,
        isFatal: false,
        msg: error
      }, { root: true })
    }
  },
  async getAllAccounts ({ commit, rootState }, data) {
    commit('LOADING_ALLCOUNTS_FINISHED', false)
    const config = rootState.appConfig.configFile
    const appParams = JSON.parse(sessionStorage.getItem('appParams'))
    const storageAppToken = sessionStorage.getItem('token')
    const hashToken = utils.SHA256(appParams.entidad + storageAppToken + appParams.canal)
    const appProgram = sessionStorage.getItem('appProgram')
    let body = {}
    // console.log('averaver')
    // console.log(config.canal)
    // console.log(state.lang.toUpperCase())
    // console.log(config.entidad)
    // console.log(data)
    if (typeof data !== 'undefined') {
      body = Object.assign({}, {
        runService: {
          opData: {
            avanzar: data.avanzar ? data.avanzar : false,
            businesstimeout: '',
            canal: config.canal,
            claveFin: data.claveFin ? data.claveFin : '',
            claveInicio: data.claveInicio ? data.claveInicio : '',
            entidad: config.entidad,
            idioma: state.lang.toUpperCase(),
            indMasDatos: '',
            oficina: '',
            pantPagina: '',
            retroceder: data.retroceder ? data.retroceder : false,
            mainUser: appParams.mainUser,
            securityToken: hashToken
          },
          eEntrada: {
            cantpunt: 0,
            cliente: '',
            codcuent: '',
            codentid: config.entidad,
            codprogr: appProgram,
            desctidc: '',
            estado: '',
            idclient: '',
            indblqac: '',
            indblqrd: '',
            tipcons: data.tipCons ? data.tipCons : 'T'
          }
        }
      })
    } else {
      body = Object.assign({}, {
        runService: {
          opData: {
            avanzar: false,
            businesstimeout: '',
            canal: config.canal,
            claveFin: '',
            claveInicio: '',
            entidad: config.entidad,
            idioma: state.lang.toUpperCase(),
            indMasDatos: '',
            oficina: '',
            pantPagina: '',
            retroceder: false,
            mainUser: appParams.mainUser,
            securityToken: hashToken
          },
          eEntrada: {
            cantpunt: 0,
            cliente: '',
            codcuent: '',
            codentid: config.entidad,
            codprogr: appProgram,
            desctidc: '',
            estado: '',
            idclient: '',
            indblqac: '',
            indblqrd: '',
            tipcons: 'T'

          }
        }
      })
    }
    try {
      const response = await HTTP.post(config.endpoints.getAllAccounts, body)
      sessionStorage.setItem('token', response.data.runServiceResponse.return.securityToken)
      commit('LOADING_ALLCOUNTS_FINISHED', true)
      if (response.data.runServiceResponse.return.retorno === '039') {
        commit('SET_ERROR', {
          isError: true,
          isFatal: true,
          msg: 'La sesión ha expirado. Reinicie el registro.'
        })
      }
      if (response.data.runServiceResponse.return.retorno === '021') {
        commit('SET_ERROR', {
          isError: true,
          isFatal: true,
          msg: 'Token de seguridad incorrecto.'
        })
      }
      return response.data.runServiceResponse.return
    } catch (error) {
      commit('SET_ERROR', {
        isError: true,
        isFatal: false,
        msg: error
      }, { root: true })
    }
  },
  updateDropDown ({ commit }, data) {
    commit('SET_PROGRAM', data)
  },
  updateLang ({ commit }, data) {
    commit('SET_LANG', data)
  }
}

// mutations
const mutations = {
  'LOADING_DROP_MENU_FINISHED' (state, actions) {
    state.loadingDropMenu = actions
  },
  'SET_TYPE_ACCOUNT' (state, actions) {
    state.accountType = actions
  },
  'SET_PROGRAM' (state, actions) {
    state.appProgram = actions
  },
  'LOADING_PROGRAM_FINISHED' (state, actions) {
    state.loadingProgram = actions
  },
  'SET_DATA_PROGRAM' (state, actions) {
    state.programData = actions
  },
  'SET_DATA_COUNTS' (state, actions) {
    state.countsData = actions
  },
  'SET_LANG' (state, actions) {
    state.lang = actions
  },
  'LOADING_COMMERCE_FINISHED' (state, actions) {
    state.loadingCommerce = actions
  },
  'LOADING_TEMPLATES_FINISHED' (state, actions) {
    state.loadingTemplates = actions
  },
  'LOADING_CANALES_FINISHED' (state, actions) {
    state.loadingCanales = actions
  },
  'LOADING_ALLCOUNTS_FINISHED' (state, actions) {
    state.loadingAllCounts = actions
  },
  'LOADING_COUNTSDATA_FINISHED' (state, actions) {
    state.loadingCountsData = actions
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
